define('modules/pagination/pagination_item_collection',['backbone', './pagination_item_model'], function (Backbone, PaginationItem) {
  'use strict';
  var PaginationItemCollection = Backbone.Collection.extend({
    model: PaginationItem,
    initialize: function (models, options) {

    }
  });

  return PaginationItemCollection;
});
